import React from 'react';

import ArticleCardSmall from './ArticleCardSmall';
import ArticleCardSmallStory from './ArticleCardSmallStory';

const ArticleGrid = (props) => {
    return (
        <div className="articles-grid">
            <div className="row-grid">
                {props.articles && props.articles.length >= 1 && props.articles.map((article) => {
                    if(props.isStory){
                        return <ArticleCardSmallStory handleUserId={props.handleUserId}
                                               key={article._id}
                                               {...article}
                                               userStories={props.userStories}
                        />
                    } else {
                        return <ArticleCardSmall handleUserId={props.handleUserId}
                                          key={article._id}
                                          {...article}
                                          userStories={props.userStories}
                        />
                    }}
                )}
                {props.type === "pageBlog" && props.total === 0 && (
                    <div className="no-content">Il n'y a aucun article sur ce blog</div>
                )}
            </div>
        </div>
    )
};

export default ArticleGrid;
